module.exports = __webpack_public_path__ + "img/np.ee0ccfb3.svg";